import HBIcon from "@/components/HBIcon";
import classNames from "classnames";
import { CSSProperties, ReactNode, useEffect, useRef } from "react";
import { When } from "react-if";
import styles from "./index.module.less";

interface SearchAssociateProps {
  data?: Array<{
    word: string;
    html: string;
    type?: string;
    total?: number;
  }>;
  selected: number;
  onSelect: (index: number) => void;
  preAddOn?: ReactNode;
  onSearch: (word: string, params: any) => void;
  wrapStyle?: CSSProperties;
}

/**
 * 搜索下拉框联想词
 */
export default function SearchAssociate({
  data = [],
  selected,
  onSelect,
  preAddOn = null,
  onSearch,
  wrapStyle = {},
}: SearchAssociateProps) {
  const wrapperRef = useRef(null);

  // 滚动到响应位置
  useEffect(() => {
    wrapperRef.current?.querySelector(`.${styles.active}`)?.scrollIntoView();
  }, [selected]);

  if (preAddOn === null && !data.length) {
    return null;
  }

  return (
    <div
      className={styles["associate-dropdown"]}
      id="search_dropdown"
      ref={wrapperRef}
    >
      {preAddOn}

      <When condition={preAddOn && data?.length}>
        <div className={styles.split} />
      </When>

      {data?.length ? (
        <>
          <ul className={styles.associate} style={wrapStyle}>
            {data.map(({ word, html, type, total }, index) => (
              <li
                key={word + index}
                className={classNames({
                  [styles.active]: selected === index,
                  [styles.material]: type === "material",
                })}
                onMouseOver={() => {
                  if (index === selected) return;
                  onSelect(index);
                }}
                onClick={() => {
                  onSearch(word, {
                    type: `联想搜索词${type ? "-素材" : ""}`,
                    query: type
                      ? {
                          type,
                        }
                      : null,
                  });
                }}
                data-gd-expose="button_expose"
                data-button-name={word}
                data-content-source="联想搜索词"
                data-gd-click="button_click"
              >
                {type === "material" ? (
                  <>
                    <HBIcon className={styles.rightIcon} type="ic_copyright" />
                    <span dangerouslySetInnerHTML={{ __html: html }}></span>
                    <div className={styles.num}>
                      {Number(total) === 10000 ? "9999+" : total} 商用素材
                    </div>
                  </>
                ) : (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: html,
                    }}
                  ></span>
                )}
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </div>
  );
}
